import { render, staticRenderFns } from "./CompassIcon.vue?vue&type=template&id=61838950"
import script from "./CompassIcon.vue?vue&type=script&lang=js"
export * from "./CompassIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports